<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="form-group xrx-audio-convert portal-wrapper">
  @if (serviceIndex === 0)
  {
  <!--single workflow or first service in combo workflow-->
  <div [ngClass]="{'service-params': !isAutomated}">
    <div class="property-select">
      <xrx-select [label]="'SDE_LANGUAGE'"
                  [list]="list"
                  [(selectedItem)]="languageOption"
                  [localize]="'key'" [property]="'key'" [orderby]="'key'"
                  (change)="onLanguageSelected()" [isInputOnly]="true">
      </xrx-select>
    </div>
  </div>
  } @else {
  <!--combo workflow preceeded by translate or summarize with language setting -->
  <label class="mb-0" [xdaTranslate]="'SDE_LANGUAGE'"></label>
  <div class="only-option" [xdaTranslate]="'SDE_FMTSTR_SELECTED_PREVIOUS'" [formatValues]="languageOption.key"></div>
  }

  <label class="mt-1 mb-0" [xdaTranslate]="'SDE_GENDER'"></label>
  @if (bothGenderVoices)
  {
  <div class="cb">
    <xrx-radio id="radio"
               [list]="genderOptions"
               property="value"
               localize="display"
               [(checkedItem)]="genderOption"
               (checkedItemChange)="onGenderSelected()">
    </xrx-radio>
  </div>
  } @else {
  <div class="only-option" [xdaTranslate]="'SDE_ONLY_OPTION_AVAILABLE'" [formatValues]="genderOption.display!"></div>
  }

  <label class="mt-2 mb-0" [xdaTranslate]="'SDE_ACCENT_LOCATION'"></label>
  @if (languageOption.options?.length! > 1) {
  <div [ngClass]="{'service-params': !isAutomated}" class="mt-2">
    <div class="property-select">
      <xrx-select [list]="languageOption.options!"
                  [(selectedItem)]="locationOption"
                  [localize]="'key'" [property]="'key'" [orderby]="'key'"
                  (change)="onLocationSelected()" [isInputOnly]="true">
      </xrx-select>
    </div>
  </div>
  } @else
  {
  <div class="only-option mb-4" [xdaTranslate]="'SDE_ONLY_OPTION_AVAILABLE'" [formatValues]="locationOption.key"></div>
  }

  @if (audioSampleFile)
  {
  <button type="button"
          class="xrx-btn btn-secondary xgl-volume_high"
          (click)="playAudioSample()">
    <span class="btn-label" [xdaTranslate]="!audioPlayer ? 'SDE_PLAY_AUDIO_SAMPLE' : 'SDE_STOP_AUDIO_SAMPLE'"></span>
  </button>
  }

</div>

